import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import  Booking from "../../components/Booking/BookingListLayer";

const BookingList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Booking Management"  />

        <Booking />
      </MasterLayout>
    </>
  );
};

export default BookingList;
